import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "citizenTab",
  class: ""
}
const _hoisted_2 = { class: "actions text-end mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 border-rounded-gray"
}
const _hoisted_4 = { class: "ucheader" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = { class: "Title" }
const _hoisted_7 = { class: "right" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "row mb-3" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "inputWrapper" }
const _hoisted_13 = { class: "inputWrapper" }
const _hoisted_14 = { class: "inputWrapper" }
const _hoisted_15 = { class: "inputWrapper" }
const _hoisted_16 = { class: "inputWrapper align-bottom" }
const _hoisted_17 = { class: "inputWrapper align-bottom" }
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = { class: "card" }
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = { class: "inputWrapper align-top" }
const _hoisted_22 = { class: "inputWrapper align-top" }
const _hoisted_23 = { class: "inputWrapper align-top" }
const _hoisted_24 = { class: "inputWrapper align-top" }
const _hoisted_25 = { class: "vstack gap-3 mb-3" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 1,
  class: "card"
}
const _hoisted_28 = { class: "card-header" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-6 text-end" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "card-body" }
const _hoisted_33 = { class: "inputWrapper" }
const _hoisted_34 = { class: "inputWrapper" }
const _hoisted_35 = { class: "inputWrapper" }
const _hoisted_36 = { class: "my-3 container-fluid" }
const _hoisted_37 = {
  class: "row border bg-light d-flex align-items-center",
  style: {"height":"56px"}
}
const _hoisted_38 = { class: "col-2 h-100 d-flex align-items-center border-start" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 0,
  class: "row border"
}
const _hoisted_42 = { class: "vstack gap-3 mb-3" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 1,
  class: "card"
}
const _hoisted_45 = { class: "card-header" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-6 text-end" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "card-body" }
const _hoisted_50 = {
  class: "row border bg-light",
  style: {"height":"56px"}
}
const _hoisted_51 = { class: "p-2 h-100 d-flex align-items-center col-2 border-start" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "actions text-end mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_age_exact_range_radio_buttons = _resolveComponent("age-exact-range-radio-buttons")!
  const _component_SelectField = _resolveComponent("SelectField")!
  const _component_age_select_with_range = _resolveComponent("age-select-with-range")!
  const _component_search_container = _resolveComponent("search-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "mt-2 me-2 btn btn-primary",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.handleAddCitizen()), ["prevent"]))
      }, "Add a Citizen")
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactFullReport!.citizens, (citizen, citizenIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row px-3 py-2",
        key: _ctx.keyColumn
      }, [
        (_ctx.contactFullReport!.citizens != undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, "Citizen " + _toDisplayString(citizenIndex + 1), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "btn btn-link confirm-remove",
                    onClick: _withModifiers(($event: any) => (_ctx.handleRemoveForCitizen(citizenIndex)), ["prevent"])
                  }, "Remove", 8, _hoisted_8)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"validationSideBySideDiv\"><div class=\"left\"><label style=\"font-weight:bold;\">Age <span class=\"requiredfieldasterisk\">*</span></label></div><div class=\"right\"><span style=\"color:Red;visibility:hidden;\">Required</span></div></div>", 1)),
                _createVNode(_component_age_exact_range_radio_buttons, {
                  index: citizenIndex,
                  modelValue: citizen.perceived_information.age,
                  "onUpdate:modelValue": ($event: any) => ((citizen.perceived_information.age) = $event),
                  "is-horizontal": true,
                  "is-disabled": false,
                  "is-required": true,
                  ref_for: true,
                  ref: (el) => { _ctx.addValidatableComponent(el) }
                }, null, 8, ["index", "modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"validationSideBySideDiv\"><div class=\"left\"><label style=\"font-weight:bold;\">Gender <span class=\"requiredfieldasterisk\">*</span></label></div><div class=\"right\"><span style=\"color:Red;visibility:hidden;\">Required</span></div></div>", 1)),
                    _createVNode(_component_SelectField, {
                      modelValue: citizen.perceived_information.gender,
                      "onUpdate:modelValue": ($event: any) => ((citizen.perceived_information.gender) = $event),
                      "select-items": _ctx.contactsStore.getGender,
                      "is-horizontal": false,
                      "is-required": true,
                      ref_for: true,
                      ref: (el) => { _ctx.addValidatableComponent(el) }
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"validationSideBySideDiv\"><div class=\"left\"><label style=\"font-weight:bold;\">Race <span class=\"requiredfieldasterisk\">*</span></label></div><div class=\"right\"><span style=\"color:Red;visibility:hidden;\">Required</span></div></div>", 1)),
                    _createVNode(_component_SelectField, {
                      modelValue: citizen.perceived_information.race,
                      "onUpdate:modelValue": ($event: any) => ((citizen.perceived_information.race) = $event),
                      "select-items": _ctx.contactsStore.getRace,
                      "is-horizontal": false,
                      "is-required": true,
                      ref_for: true,
                      ref: (el) => { _ctx.addValidatableComponent(el) }
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"validationSideBySideDiv\"><div class=\"left\"><label style=\"font-weight:bold;\">Ethnicity <span class=\"requiredfieldasterisk\">*</span></label></div><div class=\"right\"><span style=\"color:Red;visibility:hidden;\">Required</span></div></div>", 1)),
                    _createVNode(_component_SelectField, {
                      modelValue: citizen.perceived_information.ethnicity,
                      "onUpdate:modelValue": ($event: any) => ((citizen.perceived_information.ethnicity) = $event),
                      "select-items": _ctx.contactsStore.getEthnicity,
                      "is-horizontal": false,
                      "is-required": true,
                      ref_for: true,
                      ref: (el) => { _ctx.addValidatableComponent(el) }
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"validationSideBySideDiv\"><div class=\"left\"><label style=\"font-weight:bold;\">Contact Reason <span class=\"requiredfieldasterisk\">*</span></label></div><div class=\"right\"><span style=\"color:Red;visibility:hidden;\">Required</span></div></div>", 1)),
                    _createVNode(_component_SelectField, {
                      modelValue: citizen.contact_reason,
                      "onUpdate:modelValue": ($event: any) => ((citizen.contact_reason) = $event),
                      "select-items": _ctx.contactsStore.getContactReason,
                      "is-horizontal": false,
                      "is-required": true,
                      ref_for: true,
                      ref: (el) => { _ctx.addValidatableComponent(el) }
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "validationSideBySideDiv" }, [
                      _createElementVNode("div", { class: "left" }, [
                        _createElementVNode("label", { style: {"font-weight":"bold"} }, "Suspected Offenses")
                      ]),
                      _createElementVNode("div", { class: "right" })
                    ], -1)),
                    _createVNode(_component_SelectField, {
                      modelValue: citizen.suspected_offenses,
                      "onUpdate:modelValue": ($event: any) => ((citizen.suspected_offenses) = $event),
                      "select-items": _ctx.contactsStore.getCrimeCategorySuspected,
                      mode: 'tags',
                      "is-required": false,
                      ref_for: true,
                      ref: (el) => { _ctx.addValidatableComponent(el) }
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "validationSideBySideDiv" }, [
                      _createElementVNode("div", { class: "left" }, [
                        _createElementVNode("label", { style: {"font-weight":"bold"} }, "Information Collected")
                      ]),
                      _createElementVNode("div", { class: "right" })
                    ], -1)),
                    _createVNode(_component_SelectField, {
                      modelValue: citizen.information_collected,
                      "onUpdate:modelValue": ($event: any) => ((citizen.information_collected) = $event),
                      "select-items": _ctx.contactsStore.getInformationCollected,
                      mode: 'tags',
                      "is-required": false,
                      ref_for: true,
                      ref: (el) => { _ctx.addValidatableComponent(el) }
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-header" }, " Offense Information ", -1)),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"validationSideBySideDiv\"><div class=\"left\"><label style=\"font-weight:bold;\">Action Taken <span class=\"requiredfieldasterisk\">*</span></label></div><div class=\"right\"><span style=\"color:Red;visibility:hidden;\">Required</span></div></div>", 1)),
                      _createVNode(_component_SelectField, {
                        modelValue: citizen.action_taken,
                        "onUpdate:modelValue": ($event: any) => ((citizen.action_taken) = $event),
                        "select-items": _ctx.contactsStore.getContactOutcome,
                        mode: 'tags',
                        "is-required": true,
                        "is-action-taken": true,
                        ref_for: true,
                        ref: (el) => { _ctx.addValidatableComponent(el) }
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "validationSideBySideDiv" }, [
                        _createElementVNode("div", { class: "left" }, [
                          _createElementVNode("label", { style: {"font-weight":"bold"} }, "Arrest Offenses")
                        ]),
                        _createElementVNode("div", { class: "right" })
                      ], -1)),
                      _createVNode(_component_SelectField, {
                        modelValue: citizen.arrest_offenses,
                        "onUpdate:modelValue": ($event: any) => ((citizen.arrest_offenses) = $event),
                        "select-items": _ctx.contactsStore.getCrimeCategoryCommitted,
                        mode: 'tags',
                        "is-required": false,
                        ref_for: true,
                        ref: (el) => { _ctx.addValidatableComponent(el) }
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "validationSideBySideDiv" }, [
                        _createElementVNode("div", { class: "left" }, [
                          _createElementVNode("label", { style: {"font-weight":"bold"} }, "Citation Offenses")
                        ]),
                        _createElementVNode("div", { class: "right" })
                      ], -1)),
                      _createVNode(_component_SelectField, {
                        modelValue: citizen.citation_offenses,
                        "onUpdate:modelValue": ($event: any) => ((citizen.citation_offenses) = $event),
                        "select-items": _ctx.contactsStore.getCrimeCategoryCommitted,
                        mode: 'tags',
                        "is-required": false,
                        ref_for: true,
                        ref: (el) => { _ctx.addValidatableComponent(el) }
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "validationSideBySideDiv" }, [
                        _createElementVNode("div", { class: "left" }, [
                          _createElementVNode("label", { style: {"font-weight":"bold"} }, "Warning Offenses")
                        ]),
                        _createElementVNode("div", { class: "right" })
                      ], -1)),
                      _createVNode(_component_SelectField, {
                        modelValue: citizen.warning_offenses,
                        "onUpdate:modelValue": ($event: any) => ((citizen.warning_offenses) = $event),
                        "select-items": _ctx.contactsStore.getCrimeCategorySuspected,
                        mode: 'tags',
                        "is-required": false,
                        ref_for: true,
                        ref: (el) => { _ctx.addValidatableComponent(el) }
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                (citizen.use_of_force_details == null)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "mb-3 d-block btn btn-outline-secondary maxwidth375",
                      onClick: _withModifiers(($event: any) => (_ctx.addUOFDetails(citizen)), ["prevent"])
                    }, "Add Use of Force Details", 8, _hoisted_26))
                  : _createCommentVNode("", true),
                (citizen.use_of_force_details != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-6 text-start" }, " Force Used on Citizen ", -1)),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("button", {
                              class: "btn-close me-3",
                              "aria-label": "Remove",
                              onClick: _withModifiers(($event: any) => (_ctx.handleRemoveUOFDetails(citizen)), ["prevent"])
                            }, null, 8, _hoisted_31)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "validationSideBySideDiv" }, [
                            _createElementVNode("div", { class: "left" }, [
                              _createElementVNode("label", { style: {"font-weight":"bold"} }, "Injury Severity")
                            ]),
                            _createElementVNode("div", { class: "right" })
                          ], -1)),
                          _createVNode(_component_SelectField, {
                            modelValue: citizen.use_of_force_details.injury,
                            "onUpdate:modelValue": ($event: any) => ((citizen.use_of_force_details.injury) = $event),
                            "select-items": _ctx.contactsStore.getInjurySeverity,
                            "is-horizontal": false,
                            "is-required": false,
                            ref_for: true,
                            ref: (el) => { _ctx.addValidatableComponent(el) }
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "validationSideBySideDiv" }, [
                            _createElementVNode("div", { class: "left" }, [
                              _createElementVNode("label", { style: {"font-weight":"bold"} }, "Ambulance Called")
                            ]),
                            _createElementVNode("div", { class: "right" })
                          ], -1)),
                          _createVNode(_component_SelectField, {
                            modelValue: citizen.use_of_force_details.ambulance_called,
                            "onUpdate:modelValue": ($event: any) => ((citizen.use_of_force_details.ambulance_called) = $event),
                            "select-items": _ctx.contactsStore.getYesNoUnknown,
                            "is-horizontal": false,
                            "is-required": false,
                            ref_for: true,
                            ref: (el) => { _ctx.addValidatableComponent(el) }
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "validationSideBySideDiv" }, [
                            _createElementVNode("div", { class: "left" }, [
                              _createElementVNode("label", { style: {"font-weight":"bold"} }, "Citizen Transported")
                            ]),
                            _createElementVNode("div", { class: "right" })
                          ], -1)),
                          _createVNode(_component_SelectField, {
                            modelValue: citizen.use_of_force_details.transported,
                            "onUpdate:modelValue": ($event: any) => ((citizen.use_of_force_details.transported) = $event),
                            "select-items": _ctx.contactsStore.getYesNoUnknown,
                            "is-horizontal": false,
                            "is-required": false,
                            ref_for: true,
                            ref: (el) => { _ctx.addValidatableComponent(el) }
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _cache[21] || (_cache[21] = _createElementVNode("h4", null, "Weapons Shown", -1)),
                          _createElementVNode("div", _hoisted_37, [
                            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col-5 h-100 d-flex align-items-center" }, "Weapon Type", -1)),
                            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col-5 h-100 d-flex align-items-center border-start" }, "Shown Before Force Used on Citizen", -1)),
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("button", {
                                class: "btn btn-primary",
                                onClick: _withModifiers(($event: any) => (_ctx.addWeaponsShown(citizen.use_of_force_details!)), ["prevent"])
                              }, "Add", 8, _hoisted_39)
                            ])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(citizen.use_of_force_details?.weapons_exhibited, (currentExhibitedWeapon, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "row border d-flex align-items-center",
                              key: _ctx.keyColumn
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(index) }, "col-5 p-2"])
                              }, [
                                _createVNode(_component_SelectField, {
                                  modelValue: currentExhibitedWeapon.exhibited_weapon,
                                  "onUpdate:modelValue": ($event: any) => ((currentExhibitedWeapon.exhibited_weapon) = $event),
                                  "select-items": _ctx.contactsStore.getSubjectWeaponType,
                                  "is-horizontal": false,
                                  "is-required": true,
                                  ref_for: true,
                                  ref: (el) => { _ctx.addValidatableComponent(el) }
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(index) }, "col-5 p-2"])
                              }, [
                                _createVNode(_component_SelectField, {
                                  modelValue: currentExhibitedWeapon.before_uof,
                                  "onUpdate:modelValue": ($event: any) => ((currentExhibitedWeapon.before_uof) = $event),
                                  "select-items": _ctx.contactsStore.getYesNoUnknown,
                                  "is-horizontal": false,
                                  "is-required": true,
                                  ref_for: true,
                                  ref: (el) => { _ctx.addValidatableComponent(el) }
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(index) }, "col-2 p-2 text-end"])
                              }, [
                                _createElementVNode("button", {
                                  class: "btn-close me-3",
                                  "aria-label": "Remove",
                                  onClick: _withModifiers(($event: any) => (_ctx.handleRemove(citizen.use_of_force_details?.weapons_exhibited, index)), ["prevent"])
                                }, null, 8, _hoisted_40)
                              ], 2)
                            ]))
                          }), 128)),
                          (citizen.use_of_force_details == undefined || citizen.use_of_force_details.weapons_exhibited == undefined)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [...(_cache[20] || (_cache[20] = [
                                _createElementVNode("div", { class: "col-12" }, " No data to display ", -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_42, [
                (citizen.showup_details == null)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "mb-3 d-block btn btn-outline-secondary maxwidth375",
                      onClick: _withModifiers(($event: any) => (_ctx.addShowupInfo(citizen)), ["prevent"])
                    }, "Add Show-up Information", 8, _hoisted_43))
                  : _createCommentVNode("", true),
                (citizen.showup_details != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-6 my-auto" }, " Show-up Information ", -1)),
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("button", {
                              class: "btn-close me-3",
                              "aria-label": "Remove",
                              onClick: _withModifiers(($event: any) => (_ctx.handleRemoveShowUpInformation(citizen)), ["prevent"])
                            }, null, 8, _hoisted_48)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"p-2 h-100 d-flex align-items-center col\">Age of Witness</div><div class=\"p-2 h-100 d-flex align-items-center col border-start\">Gender of Witness</div><div class=\"p-2 h-100 d-flex align-items-center col border-start\">Race of Witness</div><div class=\"p-2 h-100 d-flex align-items-center col border-start\">Ethnicity of Witness</div><div class=\"p-2 h-100 d-flex align-items-center col border-start\">Outcome of Show-up</div>", 5)),
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("button", {
                              class: "btn btn-primary",
                              onClick: _withModifiers(($event: any) => (_ctx.addShowupInfo(citizen)), ["prevent"])
                            }, "Add", 8, _hoisted_52)
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(citizen.showup_details, (data, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row border d-flex align-items-center",
                            key: _ctx.keyColumn
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(index) }, "col p-2 text-center"])
                            }, [
                              _createVNode(_component_age_select_with_range, {
                                modelValue: citizen.showup_details[index].witness_information.age,
                                "onUpdate:modelValue": ($event: any) => ((citizen.showup_details[index].witness_information.age) = $event),
                                "is-horizontal": false,
                                "is-required": true
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(index) }, "col p-2 border-start text-center"])
                            }, [
                              _createVNode(_component_SelectField, {
                                modelValue: citizen.showup_details[index].witness_information.gender,
                                "onUpdate:modelValue": ($event: any) => ((citizen.showup_details[index].witness_information.gender) = $event),
                                "select-items": _ctx.contactsStore.getGender,
                                "is-horizontal": false,
                                "is-required": true,
                                ref_for: true,
                                ref: (el) => { _ctx.addValidatableComponent(el) }
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(index) }, "col p-2 border-start text-center"])
                            }, [
                              _createVNode(_component_SelectField, {
                                modelValue: citizen.showup_details[index].witness_information.race,
                                "onUpdate:modelValue": ($event: any) => ((citizen.showup_details[index].witness_information.race) = $event),
                                "select-items": _ctx.contactsStore.getRace,
                                "is-horizontal": false,
                                "is-required": true,
                                ref_for: true,
                                ref: (el) => { _ctx.addValidatableComponent(el) }
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(index) }, "col p-2 border-start text-center"])
                            }, [
                              _createVNode(_component_SelectField, {
                                modelValue: citizen.showup_details[index].witness_information.ethnicity,
                                "onUpdate:modelValue": ($event: any) => ((citizen.showup_details[index].witness_information.ethnicity) = $event),
                                "select-items": _ctx.contactsStore.getEthnicity,
                                "is-horizontal": false,
                                "is-required": true,
                                ref_for: true,
                                ref: (el) => { _ctx.addValidatableComponent(el) }
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(index) }, "col p-2 border-start text-center"])
                            }, [
                              _createVNode(_component_SelectField, {
                                modelValue: citizen.showup_details[index].showup_outcome,
                                "onUpdate:modelValue": ($event: any) => ((citizen.showup_details[index].showup_outcome) = $event),
                                "select-items": _ctx.contactsStore.getShowUpIdOutcome,
                                "is-horizontal": false,
                                "is-required": true,
                                ref_for: true,
                                ref: (el) => { _ctx.addValidatableComponent(el) }
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(index) }, "col-2 p-2 border-start mt-1 text-end"])
                            }, [
                              _createElementVNode("button", {
                                class: "btn-close me-3",
                                "aria-label": "Remove",
                                onClick: _withModifiers(($event: any) => (_ctx.handleRemove(citizen.showup_details, index)), ["prevent"])
                              }, null, 8, _hoisted_53)
                            ], 2)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactsStore.getWhatSearched, (searchDetailsData, searchDetailsIndex) => {
                return (_openBlock(), _createElementBlock("div", { key: _ctx.keyColumn }, [
                  _createVNode(_component_search_container, {
                    index: citizenIndex,
                    "search-details-data": searchDetailsData,
                    "search-details-index": searchDetailsIndex,
                    ref_for: true,
                    ref: (el) => { _ctx.addValidatableComponent(el) }
                  }, null, 8, ["index", "search-details-data", "search-details-index"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _withDirectives(_createElementVNode("div", _hoisted_54, [
      _createElementVNode("button", {
        class: "btn btn-primary mb-2 me-2",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.handleAddCitizen()), ["prevent"]))
      }, "Add a Citizen")
    ], 512), [
      [_vShow, _ctx.contactsStore.contactFullReport!.citizens && _ctx.contactsStore.contactFullReport!.citizens.length > 0]
    ])
  ]))
}